// PickupSellerTable.jsx
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import TableLoader from "../../../loader/TableLoader";
import {
  capitalizeFirstLetter,
  handleDateSetUp,
  NoItemsLeftInTable,
} from "../../../../helpers/helpers";
import { Modal } from "react-materialize";
import {
  allPickupDetails,
  cancelPickupRequest,
  completdPickupRequest,
} from "../../../../redux/action/bids";
import SpecificDate from "../children/SpecificDate";
import RerenderSellerButton from "../children/RerenderSellerButton";
import Paginations from "../../pagination/Paginations";

function PickupSellerTable() {
  const totalNumberRow = 30;
  const dispatch = useDispatch();
  const [pickupId, setPickupId] = useState("");
  const [modalType, setModalType] = useState(null);
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageVisited, setMaxPageVisited] = useState(1);
  const { accountType } = useSelector((state) => state.account);
  const { allPickup, loadings } = useSelector((pre) => pre.allPickup);
  const handleActionClick = (id, type) => {
    setPickupId(id);
    setModalType(type);
  };

  const handleRequestAction = (action) => {
    const actionFunction =
      action === "cancel" ? cancelPickupRequest : completdPickupRequest;
    dispatch(actionFunction(pickupId)).then(() => {
      setPickupId("");
      setModalType(null);
      dispatch(allPickupDetails(accountType));
    });
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "pending":
        return "yellow-text text-darken-1";
      case "cancelled":
      case "reject":
        return "red-text";
      case "accepted":
        return "purple-text";
      default:
        return "green-text";
    }
  };

  useEffect(() => {
    dispatch(allPickupDetails(currentPage, totalNumberRow, accountType));
  }, [dispatch, accountType, currentPage, totalNumberRow]);

  if (loadings) {
    return (
      <div className="valign-wrapper justify-center cover white">
        <TableLoader
          headerData={[
            "Auction Id",
            "Trader",
            "Scrap Type",
            "Pickup Time",
            "Pickup Date",
            "Assistant",
          ]}
          height={"170px"}
        />
      </div>
    );
  }

  return (
    <div>
      <div className="table-container-style mt-1">
        <table
          className={`responsive-table centered ${
            isTablet ? "auction_table table-style" : "custom-table-style"
          }`}
        >
          <thead>
            <tr>
              <th>Auction Id</th>
              <th>Trader</th>
              <th>Scrap Type</th>
              <th>Quantity</th>
              <th>Pickup Time</th>
              <th>Pickup Date</th>
              <th>Assistant</th>
              <th>Location</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allPickup
              ?.slice()
              ?.reverse()
              ?.map((item, index) => (
                <tr key={item?._id}>
                  <td>{item?.auction?.auctionId}</td>
                  <td>{item?.buyer?.organizationName}</td>
                  <td>{item?.scrapDetails?.type}</td>
                  <td>
                    {item?.scrapDetails?.quantity}/{item?.scrapDetails?.unit}
                  </td>
                  <td>
                    {item?.pickupTime?.type === "specificTime"
                      ? item?.pickupTime?.startingTime
                      : `${item?.pickupTime?.timeRange?.startTime} - ${item?.pickupTime?.timeRange?.endTime}`}
                  </td>
                  <td style={{ width: "150px" }}>
                    <span className="NoOfline" style={{ WebkitLineClamp: 1 }}>
                      {item?.pickupDate?.type === "deadline" ? (
                        handleDateSetUp(item?.pickupDate?.deadLine)
                      ) : (
                        <SpecificDate
                          specificDates={item?.pickupDate?.specificDates}
                          toolValue={`tooltip-${item?._id}/date`}
                        />
                      )}
                    </span>
                  </td>
                  <td style={{ width: !isTablet && "100px" }}>
                    {item?.loadingAssistance ? "Yes" : "No"}
                  </td>
                  <td style={{ width: !isTablet && "200px" }}>
                    <p
                      className="NoOfline pointer"
                      style={{ WebkitLineClamp: 1 }}
                      data-tooltip-id={`tooltip-${item?._id}/location`}
                    >
                      {item?.pickupLocation?.address}
                    </p>
                  </td>
                  <td>
                    <span className={getStatusClass(item?.status)}>
                      {capitalizeFirstLetter(item?.status)}
                    </span>
                  </td>
                  <td>
                    <RerenderSellerButton
                      item={item}
                      handleActionClick={handleActionClick}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {allPickup?.length === 0 && !loadings && <NoItemsLeftInTable />}
      </div>
      {allPickup?.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalNumberRow={totalNumberRow}
          totalData={allPickup?.length}
          maxPageVisited={maxPageVisited}
          setMaxPageVisited={setMaxPageVisited}
        />
      )}
      <Modal
        actions={[]}
        id="actionModal"
        open={!!modalType}
        options={{
          onCloseEnd: () => setModalType(null),
        }}
      >
        <h3 className="normal-size margin-0px">
          Confirm to {modalType === "cancel" ? "Cancel" : "Complete"} Pickup
        </h3>
        <p className="font-16px">
          Could you please confirm if you would like to{" "}
          {modalType === "cancel" ? "cancel" : "complete"} the scheduled pickup?
          Your confirmation is required for processing.
        </p>
        <div className="flex justify-end gap-1 mt-1">
          <button
            className="green btn-small"
            onClick={() => handleRequestAction(modalType)}
          >
            Yes
          </button>
          <button
            className="red btn-small modal-close"
            onClick={() => setModalType(null)}
          >
            No
          </button>
        </div>
      </Modal>
      {allPickup?.map((item) => (
        <React.Fragment key={item?._id}>
          <ReactTooltip
            id={`tooltip-${item?._id}/location`}
            place="top"
            content={
              <p style={{ width: "200px" }}>{item?.pickupLocation?.address}</p>
            }
          />
          <ReactTooltip
            id={`tooltip-${item?._id}/date`}
            place="top"
            content={
              <div
                className="valign-wrapper justify-center column"
                style={{ width: "130px" }}
              >
                {item?.pickupDate?.specificDates?.map((date, index) => (
                  <p key={index}>Date: {handleDateSetUp(date)}</p>
                ))}
              </div>
            }
          />
        </React.Fragment>
      ))}
    </div>
  );
}

export default PickupSellerTable;
